const codes = require('./codes');
module.exports = Object.values(codes);
